import { Experiences } from '@/src/experiences'
import { Platform } from 'react-native'
import { topTabBarHeight, useIsTabBarPositionedTop } from '@/src/common/components/TopTabBar'
import { mesaColorNames } from '@/src/common/theme'

export const unstable_settings = {
  initialRouteName: 'index',
}

export default function Layout() {
  const isTabBarPositionedTop = useIsTabBarPositionedTop()
  return (
    <Experiences.CardBenefits.Navigation.Layout
      ExpoStackProps={{
        screenOptions: {
          headerShown: false,
          statusBarBackgroundColor:
            Platform.OS === 'android' ? mesaColorNames['Greyscale/900 #152438'] : undefined,
          contentStyle: isTabBarPositionedTop && {
            backgroundColor: mesaColorNames['Mesa - Brand/Secondary #223843'],
            paddingTop: topTabBarHeight,
          },
        },
      }}
    />
  )
}
